module Meevo.Plugins.Client {
    "use strict";

    import CommunicationTypeEnum = Meevo.Model.CommunicationTypeEnum;

    /**
    * Main Section of Client
    */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Client> {

        private securityKeys = Meevo.Components.Common.SecurityKeys;
        private securityParts = Meevo.Components.Common.SecurityParts;
        public referredByFieldKey = "";
        public editReferredByFieldKey = "";
        public canUserReadReferredByField = Model.SecurityAccessEnum.Grant;
        public canUserEditReferredByField = Model.SecurityAccessEnum.Grant;
        public canViewClientStats: boolean = false;
        public missingField: any = -1;
        public securityKeyCreate = this.securityKeys.DATA_CLIENT_TAB_MAIN + this.securityParts.KEY_PART_CREATE;
        public excludeSelf: Array<any> = [];
        public globalTypeaheadCriteria: any = { isGlobal: true };
        public guardianTypeAheadCriteria: any = { 'ExcludeMinorClients': true, isGlobal: true };
        public canSendTextToPhoneNumber: boolean = false; 
        public customButtonsSet: Array<Meevo.Components.Controls.IMaintenanceFormCustomButton>;
        clientTypeTemp: any = null;
        specifyParentGuardianWhenMinorSelected: boolean;
        isEnabledOptOutOfClientInfoSellOrShare: boolean;
        guardianTemp: any;
        guardian: any;
        minorGuardianTemp: any;
        statusAccordionText:string=  "View Client Status";
        minorGuardian: any;
        _sectionSeurityKey: string;
        hadFirstVisit: boolean;
        public showUnlockButton: boolean = false;
        public showUnrestrictButton: boolean = false;
        public canHaveAccountSpendingLimit: boolean = false;
        /* Apply changes to these variables before setting the value to proper fields in model
        /* Apply changes to these variables before setting the value to proper fields in model
         * for phoneNumberWarning.ts to only validate on full change, not on every character */
        public clientFirstName: string;
        public clientMiddleName: string;
        public clientLastName: string;

        public thirdPartyIdRegex: string = "[a-zA-Z0-9-]*";
        public externalUrlRegex: string = "^((http|https)://)?[-a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)$";
        private HTTP_PREFIX = 'http://';
        private HTTPS_PREFIX = 'https://';
        public externalProtocolType: string = this.HTTPS_PREFIX;
        public externalUrlInput: string;

        clientSettings: Meevo.Plugins.BusinessInfo.IBusinessInfoClientsSettings;
        registerSettings: Meevo.Plugins.BusinessInfo.IBusinessInfoRegisterSettings;
        showPhoneDuplicatesWarning: boolean;
        showEmailDuplicatesWarning: boolean;

        previousReferredByEnum: Meevo.Model.ReferredByEnum;
        referredByExclusionList: Meevo.Model.ReferredByEnum[];
        isStudentTeacherModuleEnabled = this.securityService.hasSecurity(this.securityKeys.DATA_STUDENTTEACHERMODULE + Meevo.Components.Common.SecurityParts.KEY_PART_READ);

        get watchForPhoneDuplicates(): boolean {
            return this.model
                && !this.model.id // adding a new client only
        }

        get watchForEmailDuplicates(): boolean {
            return this.model
                && !this.model.id // adding a new client only
        }

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            public securityService: Meevo.Components.Common.ISecurityService,
            noun: Meevo.Model.NounEnum,
            appSettings: Components.Common.IAppSettings,
            protected recentClientsService: Meevo.Plugins.Client.RecentClientsService,
            protected employeeClientLinkDetails: any,
            protected newPhoneNumber: any,
            protected modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey: string,
            private context: Meevo.Components.BaseClasses.IDataMaintenanceContext,
            protected businessInfoDataService: Meevo.Components.Common.IBusinessInfoDataService,
            public $rootScope: angular.IRootScopeService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $q: ng.IQService
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings,
                sectionSecurityKey);

            this.showPhoneDuplicatesWarning = true;
            this.showEmailDuplicatesWarning = false;
            this.employeeClientLinkDetails = employeeClientLinkDetails;
            this._sectionSeurityKey = sectionSecurityKey;
            businessInfoDataService.getBusinessInfoPreferences()
                .then(settings => {
                    const data: Meevo.Plugins.BusinessInfo.IBusinessInfoClientsSettings = settings.clientsSettings;
                    this.specifyParentGuardianWhenMinorSelected = data.specifyParentGuardianWhenMinorSelected;
                    this.isEnabledOptOutOfClientInfoSellOrShare = data.enableOptOutOfClientInfoSellOrShare;
                    this.clientSettings = data;

                    const registerData: Meevo.Plugins.BusinessInfo.IBusinessInfoRegisterSettings = settings.registerSettings;
                    this.registerSettings = registerData;
                    if (this.registerSettings) {
                        if (this.registerSettings.enableClientAccountSpendingLimit && this.registerSettings.clientAccountSpendingLimit) {
                            this.canHaveAccountSpendingLimit = true;
                        }
                    }
                });

            this.hadFirstVisit = false;
            this.referredByFieldKey = this.securityKeys.DATA_CLIENT_FIELD_REFERREDBY + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
            this.editReferredByFieldKey = this.securityKeys.DATA_CLIENT_FIELD_REFERREDBY_AFTERTRANSACTIONOCCURRED + Meevo.Components.Common.SecurityParts.KEY_PART_READ;

            this.securityService.checkSecurityKey(this.referredByFieldKey).then(d => {
                this.canUserReadReferredByField = d;
            });

            this.securityService.checkSecurityKey(this.editReferredByFieldKey).then(d => {
                this.canUserEditReferredByField = d;
            });

            
            this.securityService.checkSecurityKey(this.securityKeys.DATA_CLIENT_TAB_CLIENTSTATS + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(d => {
                if (d == Model.SecurityAccessEnum.Grant) {
                    this.canViewClientStats = true;
                }
            });
            
            this.initializeReferredByExclusionList();
        }

        clearGuardianTempUnsuccessfulSave(): void {
            this.model.guardianId = null;
            this.guardian = {};
            this.guardianTemp = {};
        }

        activate(): void {
            this.customButtonsSet = [{
                text: 'LABEL_PURGE',
                clickHandler: () => {
                    return this.modalService.warning('MESSAGE_CONFIRM_PURGE', 0, false, {
                        showCancelButton: true,
                        okButtonContentKey: 'LABEL_YES',
                        cancelButtonContentKey: 'LABEL_NO',
                        cancelButtonHotKey: 'MODAL_NO_BUTTON',
                        okButtonHotKey: 'MODAL_YES_BUTTON'
                    }).then(_ => {
                        this.busyService.start();

                        let client = <Model.Client>(this.model);
                        return this.dataService
                            .customMethodData(`api/Client/${client.id}/Purge`, 'POST', { "Id": client.id, "suppressWarnings": false })
                            .then(response => {
                                if (response) {
                                    if (response.status == "409") {
                                        this.handleClientPurgeWarnings(response.data.responseStatus.errors);
                                    }
                                    else if (response.data) {
                                        this.context.deactivate();
                                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.SEARCH_MENU_DELETE_CLIENT, { "id": client.id });

                                        var resubmitRetry = 10;
                                        var resubmitFn = () => {
                                            var clientForm = $("#clientSearchbtn");
                                            if (clientForm) {
                                                clientForm.click();
                                            }
                                            else {
                                                if (resubmitRetry > 0) {
                                                    resubmitRetry--;
                                                    setTimeout(resubmitFn, 100);
                                                }
                                            }
                                        };
                                        setTimeout(resubmitFn, 100);
                                    }
                                }
                            })
                            .finally(() => {
                                this.busyService.stop();
                            });
                    })
                },
                classNames: 'meevo-button',
                disableRules: () => false,
                visibilityRules: () => (this.mode === Meevo.Model.MaintenanceFormState.Readonly && this.context["enablePurge"]),
                securityRules: this.securityKeys.DATA_CLIENT_TAB_MAIN_PURGE,
                position: 'left'
            }, {
                text: 'LABEL_UNLOCK',
                clickHandler: () => { return this.context["unlock"]() },
                classNames: 'meevo-button',
                disableRules: () => false,
                visibilityRules: () => (this.mode === Meevo.Model.MaintenanceFormState.Readonly && this.context["showUnlockButton"]),
                securityRules: this.securityKeys.DATA_CLIENT_TAB_MAIN, //_UNLOCK,
                position: 'left'
            }, {
                text: 'LABEL_UNRESTRICT',
                clickHandler: () => { return this.context["unrestrict"]() },
                classNames: 'meevo-button',
                disableRules: () => false,
                visibilityRules: () => (this.mode === Meevo.Model.MaintenanceFormState.Readonly && this.context["showUnrestrictButton"]),
                securityRules: this.securityKeys.DATA_CLIENT_FIELD_UNRESTRICT,
                position: 'left'
            }
            ];

            super.activate();
        }

        handleClientPurgeConfirm(warnings: any[]): ng.IPromise<boolean> {
            let message = this.$translate.instant('MESSAGE_CLIENT_CURRENT_NOTIFY'); 
            let messageDetails: string = '<ul style="margin:0">';
            for (let warning of warnings) {
                messageDetails += "<li>" + warning.message + "</li>";
            }
            messageDetails += '</ul>';
            message += messageDetails;
            //TODO: Translate
            //message += " Once they are deleted the client will go back to receiving their own notifications. Are you sure you want to continue?";
            message += this.$translate.instant('MESSAGE_CLIENT_CURRENT_NOTIFY_POST_PURGE');
            return this.modalService.confirm(message, Components.Modal.ModalTranslationModes.DoNotTranslate);
        }

        handleClientPurgeWarnings(warnings: any[]): ng.IPromise<any> {
            return this.handleClientPurgeConfirm(warnings)
                .then((response: boolean) => {
                    //this.saveInProgress = false;
                    if (response) {
                       return this.postPurgeConfirmation();
                    }
                    return response;
                })
                .finally(() => {
                    this.loadingInProgress = false;
                    //this.saveInProgress = false;
                });
        }
        postPurgeConfirmation(): void {
            this.busyService.start();
            this.model.noConfirmations
            let client = <Model.Client>(this.model);
              this.dataService
                .customMethodData(`api/Client/${client.id}/Purge`, 'POST', { "Id": client.id, "suppressWarnings": true })
                .then(response => {
                    if (response) {
                        if (response.status == "409") {
                            this.handleClientPurgeWarnings(response.data.responseStatus.errors);
                        }
                        else if (response.data) {
                            this.context.deactivate();
                            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.SEARCH_MENU_DELETE_CLIENT, { "id": client.id });

                            var resubmitRetry = 10;
                            var resubmitFn = () => {
                                var clientForm = $("#clientSearchbtn");
                                if (clientForm) {
                                    clientForm.click();
                                }
                                else {
                                    if (resubmitRetry > 0) {
                                        resubmitRetry--;
                                        setTimeout(resubmitFn, 100);
                                    }
                                }
                            };
                            setTimeout(resubmitFn, 100);
                        }
                    }
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }
        canShowUnlockButton(): boolean {
            console.log("show unlock = " + this.showUnlockButton);
            return this.showUnlockButton;
        }

        canShowUnrestrictedButton(): boolean {
            return this.showUnrestrictButton;
        }

        //noConfirmations: boolean = false;
        tempNotification: Array<any> = [];

        initializeGuardian() {
            if (this.model && this.model.guardianId != null) {
                this.excludeSelf = [this.model];
                if (this.model.guardianId) {
                    this.dataService.getItem(this.baseEndpoint, this.model.guardianId).then((data) => {
                        this.guardian = data;
                        let temp: any = (_.findWhere(this.guardian.phoneNumbers, { isPrimary: true }));
                        this.guardian.primaryPhoneNumberCountryCode = temp.countryCode;
                        this.guardian.primaryPhoneNumber = temp.number;
                        if (!this.model.isMinor) {
                            this.guardianTemp = this.guardian;
                        }
                    })
                }
            }
        }

       
        public sectionModelRetrieved(): void {
            let vm = <Model.Client>(this.model);
            this.processModelRetrieved(vm);
            this.takeBackup();
        }

        processModelRetrieved(vm: Model.Client) {
            if (vm) {
                vm.suppressWarnings = false;

                this.clientFirstName = vm.firstName;
                this.clientMiddleName = vm.middleName;
                this.clientLastName = vm.lastName;
                console.log(vm);
                console.log(vm.gender);
                console.log(vm.pronoun);

                if (vm.forceGenderSelection && vm.gender === Meevo.Model.GenderEnum.NotSpecified) {
                    vm.gender = null;
                }

                if (!vm.pronoun) {
                    vm.pronoun = Meevo.Model.PronounEnum.NotSpecified;
                }

                if (vm.emailAddress) {
                    if (this.recentClientsService) {
                        this.recentClientsService.clientEmail = vm.emailAddress;
                    }
                }

                if (vm.phoneNumbers) {
                    vm.phoneNumbers.forEach((item, ndx, arr) => {
                        if (!item.countryCode) {
                            item.countryCode = this.appSettings.APP_COUNTRIES[this.appSettings.APP_ISOCOUNTRYCODE].CountryCallingCode;
                        }
                    });
                }

                this.setHadFirstVisitAndHadTransaction(vm);

                this.showUnlockButton = (this.clientSettings && this.clientSettings.requireRestrictedClientToBeUnlocked && vm.isLockedForEditing);
                this.showUnrestrictButton = (this.clientSettings && this.clientSettings.doNotAllowEditingOfRestrictedClients && !vm.isLockedForEditing && vm.isRestricted);

                this.previousReferredByEnum = vm.referredByEnum;
                this.externalUrlInput = vm.externalUrl;
                this.externalUrlProtocolTypeFormat();
                if (vm.phoneNumbers) {
                    this.checkUKMobileNumber(vm.phoneNumbers);
                    this.checkSMSOptInState(vm.phoneNumbers);
                }
            }
        }

        
        accountSpendingLimitChanged(): void {
            this.model.accountSpendingLimit = this.model.effectiveAccountSpendingLimit;
        }

        revertToSettingSpendingLimit(): void {
            this.model.effectiveAccountSpendingLimit = this.registerSettings.clientAccountSpendingLimit;
            this.model.accountSpendingLimit = null; 
        }



        private static s_timeOutInstance: any;

        /**
         * Performs check to see if the client had their first visit to a location.
         */
        public setHadFirstVisit(vm: Model.Client): ng.IPromise<boolean> {
            if (vm && vm.id && !(this.securityService.hasSecurity(this.securityKeys.DATA_CLIENT_FIELD_REFERREDBY_AFTERTRANSACTIONOCCURRED + Meevo.Components.Common.SecurityParts.KEY_PART_READ))) {
                return this.dataService
                    .customMethodData(`api/client/${vm.id}/VisitDate?includeAllLocations=false`, 'GET', { includeAllLocations: false })
                    .then((response) => {
                        return (this.hadFirstVisit = angular.isDefined(response.data.firstVisitDate));
                    });
            }
            return null;
        }

        private setHadTransaction(vm: Model.Client): ng.IPromise<boolean> {
            if (vm && Model.Guard.isSomething(vm.id)) {
                return this.dataService
                    .customMethodData(`api/Client/${vm.id}/TransactionHistoryCheck/${this.identityService.current().locationId}`, 'get', null)
                    .then(response => {
                        return (this.hasTransaction = response.data);
                    });
            }
            this.hasTransaction = false;
            return null;
        }

        public setHadFirstVisitAndHadTransaction(vm: Model.Client): ng.IPromise<any> {
            if (!vm) {
                vm = <Model.Client>(this.model);
            }
            let p = this.setHadFirstVisit(vm);
            if (p) {
                return p.then(v => {
                    if (v) {
                        // if client had a first visit, then it is safe to assume that they already had a transaction
                        this.hasTransaction = true;
                    }
                    else {
                        return this.setHadTransaction(vm);
                    }
                });
            }
            return this.setHadTransaction(vm);
        }

        checkVisibiltyTable(frontEndSectionId: number): boolean {

            if (
                ((this.canUserReadReferredByField == Model.SecurityAccessEnum.Grant && this.canUserEditReferredByField == Model.SecurityAccessEnum.Grant)
                    || (this.canUserReadReferredByField == Model.SecurityAccessEnum.Grant && this.canUserEditReferredByField == Model.SecurityAccessEnum.Hide && !this.hadFirstVisit)
                    || (this.canUserReadReferredByField == Model.SecurityAccessEnum.Deny && this.canUserEditReferredByField == Model.SecurityAccessEnum.Deny && !this.hadFirstVisit)
                    || (this.canUserReadReferredByField == Model.SecurityAccessEnum.Deny && this.canUserEditReferredByField == Model.SecurityAccessEnum.Hide && !this.hadFirstVisit)
                    || (this.canUserReadReferredByField == Model.SecurityAccessEnum.Hide && this.canUserEditReferredByField == Model.SecurityAccessEnum.Hide && !this.hadFirstVisit)
                    || (this.canUserReadReferredByField == Model.SecurityAccessEnum.Grant && this.canUserEditReferredByField == Model.SecurityAccessEnum.Deny && !this.hadFirstVisit))
                && frontEndSectionId == 1) // Show First Section
            {
                return true;
            }
            else if (
                (((this.canUserReadReferredByField == Model.SecurityAccessEnum.Grant && this.canUserEditReferredByField == Model.SecurityAccessEnum.Deny)
                    || (this.canUserReadReferredByField == Model.SecurityAccessEnum.Deny && this.canUserEditReferredByField == Model.SecurityAccessEnum.Deny)) && this.hadFirstVisit)
                && frontEndSectionId == 2) // Show Second Section
            {
                return true;
            }
            else if (
                ((this.canUserReadReferredByField == Model.SecurityAccessEnum.Grant && this.canUserEditReferredByField == Model.SecurityAccessEnum.Hide && this.hadFirstVisit)
                    || (this.canUserReadReferredByField == Model.SecurityAccessEnum.Deny && this.canUserEditReferredByField == Model.SecurityAccessEnum.Hide && this.hadFirstVisit))
                && frontEndSectionId == 3) // Show Third Section
            {
                return true;
            }
            return false;
        }

        /**
        * Base class override which defines what a DEFAULT model looks like.
        */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.guardian = {};
            this.guardianTemp = {};
            // NOTE: set these values right away so that the MeevoPhoneNumber directive will load empty phone numbers when coming from another screen
            if (this.model) {
                if (this.model.phoneNumbers && this.model.phoneNumbers.length > 0) {
                    this.model.phoneNumbers.forEach((pn) => {
                        pn.number = null;
                        pn.countryCode = this.appSettings.APP_COUNTRIES[this.appSettings.APP_ISOCOUNTRYCODE].CountryCallingCode;
                    });
                }
            }
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
                this.model.suppressWarnings = false;
                if (this.employeeClientLinkDetails != null) {
                    this.model.firstName = this.employeeClientLinkDetails.firstName;
                    this.model.lastName = this.employeeClientLinkDetails.lastName;
                    this.model.prefix = this.employeeClientLinkDetails.prefix;
                    this.model.address = this.employeeClientLinkDetails.address;
                    this.model.emailAddress = this.employeeClientLinkDetails.email;
                    this.model.gender = this.employeeClientLinkDetails.gender;
                    this.model.pronoun = this.employeeClientLinkDetails.pronoun;
                    if (this.employeeClientLinkDetails.birthDate != undefined) {
                        this.model.birthDay = moment(this.employeeClientLinkDetails.birthDate).date();
                        this.model.birthMonth = moment(this.employeeClientLinkDetails.birthDate).month() + 1;
                    }
                    this.model.phoneNumbers = this.employeeClientLinkDetails.phoneNumbers;
                }
                if (this.newPhoneNumber != null) {
                    let primaryPhoneNumber = _.find(this.model.phoneNumbers, (phoneNumber: Meevo.Model.Phone) => phoneNumber.isPrimary === true);
                    primaryPhoneNumber.number = this.newPhoneNumber.number;
                    primaryPhoneNumber.countryCode = this.newPhoneNumber.countryCode;
                }
                if (data.forceGenderSelection && data.gender === Meevo.Model.GenderEnum.NotSpecified) {
                    this.model.gender = null;
                }
                this.model.phoneNumbers.forEach((item, ndx, arr) => {
                    if (!item.countryCode) {
                        item.countryCode = this.appSettings.APP_COUNTRIES[this.appSettings.APP_ISOCOUNTRYCODE].CountryCallingCode;
                    }
                });
                this.clientFirstName = this.model.firstName;
                this.clientMiddleName = this.model.middleName;
                this.clientLastName = this.model.lastName;
                this.hadFirstVisit = false;
                this.previousReferredByEnum = null;
                this.initializeReferredByExclusionList();
                this.resetExternalUrl();
            });
        }

        applyValueChange(propName: string, checkForDupe: boolean = false) {
            if (propName == 'firstName') {
                this.clientFirstName = this.model.firstName;
            }
            else if (propName == 'middleName') {
                this.clientMiddleName = this.model.middleName;
            }
            else if (propName == 'lastName') {
                this.clientLastName = this.model.lastName;
            }

            if (checkForDupe) {
                this.checkForLocationDuplicatesByPhone();
            }
        }

        public allowDuplicateClientProfile = false;
        checkForLocationDuplicates(clientDuplicateService: IClientDuplicatesSearchService): ng.IPromise<boolean> {
            return clientDuplicateService
                .getDuplicates()
                .then(list => {
                    if (list.length > 0) {
                        return clientDuplicateService
                            .showWarning(this.modalService)
                            .then((chosenClientId?: Guid) => {
                                if (chosenClientId) {
                                    this.context["goToDuplicateClientProfile"](chosenClientId);
                                }
                                else
                                {
                                    this.allowDuplicateClientProfile = true;
                                }
                                return false;
                            })
                            .catch(() => { return false; });
                    }
                    return true;
                });
        }

        public inDupePhoneCheck: boolean = false;
        private dupePhoneCheckPromise: ng.IPromise<boolean> = null;
        /**
         * Method searches for the client duplicates depending on the primary phone number, first name, last name.
         * Available only for the clientsSettings.localClientSearchOnly === true.
         * Available only during creating the new client
         */
        public checkForLocationDuplicatesByPhone(): ng.IPromise<boolean> {
            const clientDuplicateService: IClientDuplicatesSearchService = new ClientDuplicatesSearchService(this.appSettings, this.dataService, this.model, this.clientSettings, (<any>this.context).$q, NamePhoneSearchStrategy);
            if (!this.watchForPhoneDuplicates || !clientDuplicateService.valid) {
                this.showPhoneDuplicatesWarning = true;
                return this.$q.resolve(true);
            }

            if (this.inDupePhoneCheck) {
                return this.dupePhoneCheckPromise;
            }

            this.dupePhoneCheckPromise = this.checkForLocationDuplicates(clientDuplicateService)
                .catch(() => {
                    this.showPhoneDuplicatesWarning = false;
                    return false;
                })
                .finally(() => {
                    this.inDupePhoneCheck = false;
                });
            this.inDupePhoneCheck = true;

            return this.dupePhoneCheckPromise;
        }

        private inDupeEmailCheck: boolean = false;
        private dupeEmailCheckPromise: ng.IPromise<boolean> = null;
        /**
         * Method searches for the client duplicates depending on the email address.
         * Available only for the clientsSettings.localClientSearchOnly === true.
         * Available only during creating the new client
         */
        public checkForLocationDuplicatesByEmail(): ng.IPromise<boolean> {
            const clientDuplicateService: IClientDuplicatesSearchService = new ClientDuplicatesSearchService(this.appSettings, this.dataService, this.model, this.clientSettings, (<any>this.context).$q, EmailSearchStrategy);
            if (!this.watchForEmailDuplicates || !clientDuplicateService.valid) {
                this.showEmailDuplicatesWarning = true;
                return this.$q.resolve(true);
            }

            if (this.inDupeEmailCheck) {
                return this.dupeEmailCheckPromise;
            }

            this.dupeEmailCheckPromise = this.checkForLocationDuplicates(clientDuplicateService)
                .catch(() => {
                    this.model.emailAddress = '';
                    this.showEmailDuplicatesWarning = false
                    return false;
                })
                .finally(() => {
                    this.inDupeEmailCheck = false;
                });
            this.inDupeEmailCheck = true;

            return this.dupeEmailCheckPromise;
        }

        /**
        * Base class override which defines the rules to use when copying the model.
        */
        createSectionModelCopy(): Model.Client {
            this.resetExternalUrl();
            // VSTS # 56569
            // create new model and copy only select properties
            let newModel: Meevo.Model.Client = {
                address: { ...this.model.address },
                allowChargesCreditOnAccount: false,
                allowSMSNotificationOptIn: true,

                clientType: this.model.clientType,
                clientTypes: [ ...this.model.clientTypes ],
                displayName: "",
                lastName: this.model.lastName,
                doNotConfirm: false,
                familyMembers: [],
                gender: Meevo.Model.GenderEnum.NotSpecified,
                pronoun : Meevo.Model.PronounEnum.NotSpecified,
                id: null,
                isLockedForEditing: false,
                isPrivate: false,
                isRegisteredObUser: false,
                noSellSharePersonalInfo: false,
                isTransient: this.model.isTransient,
                notificationOptions: [],
                objectState: Meevo.Model.ObjectStateEnum.Active,
                onlineBookingAccess: true,
                phoneNumbers: [],
                referredByEnum: Meevo.Model.ReferredByEnum.Client,
                referredByDetail: {
                    id: this.model.id,
                    displayName: this.model.displayName,
                    firstName: this.model.firstName,
                    lastName: this.model.lastName,
                    referredBy: Meevo.Model.ReferredByEnum.Client,
                },
                referredById: this.model.id.toString(),
                referredByFirstName: this.model.firstName,
                referredByLastName: this.model.lastName,

                // settings
                forceGenderSelection: this.model.forceGenderSelection,
                requireNewClientPhoneNumber: this.model.requireNewClientPhoneNumber,
                requireNewClientEmail: this.model.requireNewClientEmail,
                requireNewClientReferralType: this.model.requireNewClientReferralType,
            };
            // phone numbers, only keep Home
            _.forEach(this.model.phoneNumbers, number => {
                let newNumber = { ...number };
                if (number.type == Meevo.Model.PhoneTypeEnum.Home) {
                    newNumber.isPrimary = true;
                }
                else {
                    newNumber.isPrimary = false;
                    newNumber.number = null;
                    newNumber.phoneNumber = null;
                    newNumber.countryCode = this.appSettings.APP_COUNTRIES[this.appSettings.APP_ISOCOUNTRYCODE].CountryCallingCode;
                    newNumber.useForSMS = false;
                    newNumber.extension = null;
                    newNumber["smsOptInStateEnum"] = null;
                    newNumber["smsOptInStateDateUpdated"] = null;
                }
                newModel.phoneNumbers.push(newNumber);
            });

            // get new client default notification settings
            this.getTemplateNotificationOptions().then((response) => {
                newModel.notificationOptions = response;
            });
        
            this.processModelRetrieved(newModel);
            return newModel;
        }

        getTemplateNotificationOptions(): any {
            return this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                if (data && data.notificationOptions) {
                    return data.notificationOptions;
                }
            });
        }

        /**
        * Handles setting the primary phone number for the client.
        * Insures that only 1 phone number is set as primary.
        * @param {Model.Phone} Selected phone number
        * @param {Model.Phone[]} Collection of client phone numbers
        * @return {}
        */
        setPrimaryPhone(phone: Model.Phone, phoneNumbers: Model.Phone[]): void {
            if (phone.isPrimary) {
                for (let i = 0; i < phoneNumbers.length; i++) {
                    if (phoneNumbers[i] !== phone) {
                        phoneNumbers[i].isPrimary = false;
                    }
                }
            } else {
                for (let i = 0; i < phoneNumbers.length; i++) {
                    if (phoneNumbers[i] !== phone) {
                        phoneNumbers[i].isPrimary = true;
                        return;
                    }
                }
            }
        }

        notificationAvabilityChanged() {
            let that = this;
            if (this.model.doNotConfirm) {

                this.scheduledNotificationOptions.forEach(function (notificationSetting, index, array) {
                    let temp = {
                        call: notificationSetting.isCallEnabled,
                        email: notificationSetting.isEmailEnabled,
                        sms: notificationSetting.isSMSEnabled,
                    }

                    that.tempNotification[index] = temp

                    notificationSetting.isCallEnabled = false;
                    notificationSetting.isEmailEnabled = false;
                    notificationSetting.isSMSEnabled = false;
                });
            }
            else {
                if (this.tempNotification.length > 0) {
                    let that = this;
                    this.scheduledNotificationOptions.forEach(function (notificationSetting, index, array) {
                        notificationSetting.isCallEnabled = that.tempNotification[index].call;
                        notificationSetting.isEmailEnabled = that.tempNotification[index].email;
                        notificationSetting.isSMSEnabled = that.tempNotification[index].sms;
                    })
                }
                else {
                    let businessNotificationSettings;
                    let borp = this.appSettings.API_ENDPOINTS.notificationSetting
                    let that = this;
                    this.dataService.customMethodData("api/notificationSetting/?BusinessType_TId=" + this.identityService.businessTypeId, "GET", undefined).then(function (result) {
                        let appointmentConfirmations = _.find(result.data.communicationTypeNotifications, function (item: any) {
                            if (item.communicationTypeDisplay == "Appointment Confirmations") {
                                return true;
                            }
                            return false;
                        });
                        that.scheduledNotificationOptions.forEach(function (notificationSetting, index, array) {

                            notificationSetting.isCallEnabled = appointmentConfirmations.isCallEnabled;
                            notificationSetting.isEmailEnabled = appointmentConfirmations.isEmailEnabled;
                            notificationSetting.isSMSEnabled = appointmentConfirmations.isSMSEnabled;
                        });
                    });

                }
            }
        }

        /**
        * Handles setting if a phone should be used for sending SMS.
        * Insures that only 1 phone number can be set for sending SMS.
        * @param {Model.Phone} Selected phone number
        * @param {Model.Phone[]} Collection of client phone numbers
        * @return {}
        */
        setUseForSMS(phone: Model.Phone, phoneNumbers: Model.Phone[]): void {
            if (phone.useForSMS) {
                for (let i = 0; i < phoneNumbers.length; i++) {
                    if (phoneNumbers[i] !== phone) {
                        phoneNumbers[i].useForSMS = false;
                    }
                }
            }
        }

        /**
        * Clears that a phone can be used for SMS if it's type changes to something other than mobile.
        * @param {Model.Phone} Selected phone number
        * @return {}
        */
        clearUseForSMS(phone: Model.Phone): void {
            if (phone.type !== Model.PhoneTypeEnum.Mobile) {
                phone.useForSMS = false;
            }
            else {
                this.checkUKMobileNumber([phone]);
            }
        }

        /**
         * Returns whether or not the supplied phone number type should
         * display the option to 'Use for SMS'.
         * @param phone
         */
        showUseForSMSOption(phone: Model.Phone) {
            return phone.type == Model.PhoneTypeEnum.Mobile;
        }

        /**
          * Returns whether or not the supplied phone number type should
          * display the SMS Opt In Status.
          * @param phone
          */
        showSMSOptInStatus(phone: Model.Phone) {
            return phone.type == Model.PhoneTypeEnum.Mobile;// && phone.useForSMS;
        }

        isWorkPhone(phone: Model.Phone) {
            return phone.type == Model.PhoneTypeEnum.Work;
        }

        isMobilePhone(phone: Model.Phone) {
            return phone.type == Model.PhoneTypeEnum.Mobile;
        }

        /**
         * Clears the referred by information.
         */
        clearReferredBy(): void {
            if (!this.previousReferredByEnum || this.previousReferredByEnum != this.model.referredByEnum) {
                let referredBy = Model.Guard.isNothing(this.model.referredByEnum) || this.model.referredByEnum === 0
                    ? null
                    : this.model.referredByEnum;

                this.model.referredByDetail = {
                    id: null,
                    displayName: null,
                    referredBy: referredBy
                };

                this.model.referredById = null;
            }
            this.previousReferredByEnum = this.model.referredByEnum;
        }

        /**
         * Fired when the referred by detail is changed.
         * This will handle clearing the item properly if the 'X' is clicked on the typeAhead.
         */
        referredByChanged(): void {
            if (this.model.referredByDetail == undefined) {
                this.model.referredById = null;
            } else {
                this.model.referredById = this.model.referredByDetail.id;
                this.model.referredByDetail.referredBy = this.model.referredByEnum;
            }
        }

        phoneNumberRequired(isPrimary: boolean): boolean {
            if (!this.model)
                return false;
            var retVal = false;
            var areAllNumbersEmpty = _.every(this.model.phoneNumbers, item => Model.Guard.isNothing(item.number));
            if (this.model.requireNewClientPhoneNumber && !this.model.isMinor && !this.model.guardianId  && areAllNumbersEmpty) {
                retVal = isPrimary;
            }
            return retVal;
        }

        emailRequired(): boolean {
            if (!this.model)
                return false;
            var retVal = false;
            // NOTE: The requirement of an email is not determined whether a value is present
            if (this.model.requireNewClientEmail && !this.model.isMinor && !this.model.guardianId) {
                retVal = true;
            }
            return retVal;
        }
        emailInvalid(): boolean {
            if (!this.model)
                return true;
            var retVal1 = true;
            let pattern = Meevo.Components.Common.Constants.REGEX_EMAIL_VALIDATOR;
            this.showEmailDuplicatesWarning = false;
            if (pattern.test(this.model.emailAddress)) {
                retVal1 = false;
            }

            return retVal1;
        }

        public hasTransaction: boolean = false;
        referralRequired(): boolean {
            return this.clientSettings.requireNewClientReferralType && !this.hasTransaction;
        }

        referralSourceRequired(): boolean {
            return this.clientSettings.requireNewClientReferralTypeSource && !this.context.isEditing;
        }

        checkMarketingEmailChk(currValue) {
            if (!this.emailInvalid()) {
                this.checkForLocationDuplicatesByEmail();
                if (currValue != "" && currValue != undefined)
                    this.model.isMarketingEmailEnabled = true;
                else
                    this.model.isMarketingEmailEnabled = false;
            }
        }

        checkEmailUseForAppointmentChk(emailAddress) {
            if (!this.model.isClientEmailOptInEnabledDefault)
                return;

            if (emailAddress != "" && emailAddress != undefined) {
                this.model.isEmailOptedIn = true;
            }
            else {
                this.model.isEmailOptedIn = false;
            }
        }

        checkSMSOptInForTextChk(phone: Model.Phone, phoneNumbers: Model.Phone[]): void {

            if (this.model.isMinor || !this.model.guardianId || this.canSendTextToPhoneNumber)
                phone.useForSMS = false;
            if (!this.model.isClientSMSOptInEnabledDefault || !this.context["smsEnabledAllLevels"]())
                return;
            if (phone.number != "" && phone.number != undefined) {
                if (phone.type == Model.PhoneTypeEnum.Mobile && !phone.useForSMS && !this.model.isMinor && !this.model.guardianId) {
                    for (let i = 0; i < phoneNumbers.length; i++) {
                        if (phoneNumbers[i] === phone) {
                            phoneNumbers[i].useForSMS = true;
                        }
                    }
                }
            }

            this.checkUKMobileNumber(phoneNumbers);
        }

        checkUKMobileNumber(phoneNumbers: Model.Phone[]): void {
            this.canSendTextToPhoneNumber = false;

            if (this.appSettings.APP_BUSINFOSETTINGS.culturalSettings.countryEnum === Model.CountryEnum.UnitedKingdom) {
                return;
            }

            for (let i = 0; i < phoneNumbers.length; i++) {
                if (phoneNumbers[i].countryCode && phoneNumbers[i].countryCode == "44" && phoneNumbers[i].type == Model.PhoneTypeEnum.Mobile) {
                    phoneNumbers[i].useForSMS = false;
                    this.canSendTextToPhoneNumber = true;
                    return;
                }
            }
        }

        checkSMSOptInState(phoneNumbers: Model.Phone[]): void {
            for (let i = 0; i < phoneNumbers.length; i++) {
                if (phoneNumbers[i].type == Model.PhoneTypeEnum.Mobile
                    && (phoneNumbers[i].smsOptInStateEnum === Model.CommunicationOptedInStateEnum.Undeliverable
                        || phoneNumbers[i].smsOptInStateEnum === Model.CommunicationOptedInStateEnum.Deactivated))
                {
                    phoneNumbers[i].useForSMS = false;
                    return;
                }
            }
        }

        /**
        * Handles disabling the email opt-in if an email address isn't present.
        * This works in conjunction w/ the context.isReadonly property.
        */
        disableEmailOptinIn(): boolean {
            let retVal = false;
            if (this.model && (!this.model.emailAddress || _.isEmpty(this.model.emailAddress))) {
                retVal = true;
                this.model.isEmailOptedIn = false;
            }
            return retVal;
        }

        beforeSetFocusOnField() {
            var that = this;
            setTimeout(function () { that.setFocusOnField(that.missingField) }, 400);
        }

        setFocusOnField(field: any) {
            switch (field) {
                case Meevo.Model.ClientAlertTypeEnum.MissingPhoneNumber:
                    $('input', $('#client-phone-details')).each(function () {
                        //                    if ($(this).val() == "" || ($(this).find(".md-text").length > 0 && $(this).find(".md-text").text() == "")) {
                        if ($(this).val() == "") {
                            $(this).focus();
                            return false;
                        }
                    });
                    break;

                case Meevo.Model.ClientAlertTypeEnum.MissingEmailAddress:
                    $('#emailAddress input').focus();
                    break;

                case Meevo.Model.ClientAlertTypeEnum.MissingContactInfo:
                    $('input, md-select', $('#client-contact-information')).each(function () {
                        if ($(this).val() == "" || ($(this).find(".md-text").length > 0 && $(this).find(".md-text").text() == "")) {
                            $(this).focus();
                            return false;
                        }
                    });
                    break;

                case Meevo.Model.ClientAlertTypeEnum.MissingReferral:
                    $("#referredby md-select").focus();
                    break;

                default:
                    $('#firstName input').focus();
                    break;
            }
        }

        onStatusexpandcollapse(Status): void {
            if (Status == "expand") {
                this.statusAccordionText="Hide Client Status"
            }
            else {
                this.statusAccordionText = "View Client Status"
            }
        }
        guardianChanged() {
            if (this.guardianTemp) {
                if (!this.guardianTemp.guardianId) {
                    if (this.guardianTemp.id) {
                        this.guardian = this.guardianTemp
                        this.model.guardianId = this.guardianTemp.id;
                    }
                }
                else {
                    let message = this.$translate.instant("MESSAGE_CLIENT_NOT_OWN", {
                        ClientDisplayName: this.guardianTemp.displayName
                    });
                    this.modalService.alert(message);
                    this.model.guardianId = null;
                    this.guardian = {};
                    this.guardianTemp = {};
                }
                /*
                if (this.minorGuardian.displayName) {
                    this.model.contactName = this.minorGuardian.displayName;
                }
                else {
                    this.model.contactEmail = undefined;
                }
                if (this.minorGuardian.primaryPhoneNumber){
                    this.model.contactPhone = this.minorGuardian.primaryPhoneNumber;
                }
                else {
                    this.model.contactEmail = undefined;
                }
                if (this.minorGuardian.primaryPhoneNumber){
                    this.model.contactEmail = this.minorGuardian.emailAddress;
                }
                else {
                    this.model.contactEmail = undefined;
                }*/
            }

        }
        guardianChangedNotifications() {
            if (this.guardianTemp) {
                if (!this.guardianTemp.guardianId) {
                    if (this.guardianTemp.id) {
                        this.guardian = this.guardianTemp
                        this.model.guardianId = this.guardianTemp.id;
                    }
                }
                else {
                      let message = this.$translate.instant("MESSAGE_CLIENT_NOT_OWN", {
                        ClientDisplayName: this.guardianTemp.displayName
                    });
                    this.modalService.alert(message);
                    this.model.guardianId = null;
                    this.guardian = {};
                    this.guardianTemp = {};
                }
            }
            else {
                this.model.guardianId = null;
                this.guardian = {};
                this.guardianTemp = {};
            }
        }
        /*MERGE: WOULD NOT COMPILE*/
        getTempType() {
            let finalType = null
            if (this.model) {
                this.model.clientTypes.forEach((item) => {
                    finalType = item;
                });
            }
            return finalType;
        };



        updateModel() {
            var existingType: boolean = false;
            if (!this.model.clientTypes) {
                this.model.clientTypes = [];
            }
            this.model.clientTypes.forEach((item, index, array) => {

                if (!item) {
                    array.splice(index, 1);
                }

                if (this.clientTypeTemp) {
                    array[index] = this.clientTypeTemp;
                }
                else {
                    array.splice(index, 1);
                }
                existingType = true;
            });

            if (!existingType) {
                this.model.clientTypes.push(this.clientTypeTemp);
            }
        }

        isEmailOptedInChanged() {
            if (this.context.isEditing && this.model.isEmailOptedIn) {
                this.model.isMarketingEmailEnabled = true;
            }
        }

        externalUrlProtocolTypeFormat(): void {
            if (Meevo.Model.Guard.isSomething(this.externalUrlInput)) {
                this.externalUrlInput = this.externalUrlInput.replace(this.HTTPS_PREFIX, '').replace(this.HTTP_PREFIX, '');
                this.externalProtocolType = this.model.externalUrl.includes(this.HTTPS_PREFIX) === true ? this.HTTPS_PREFIX : this.HTTP_PREFIX;
            }
        }

        externalUrlProtocolTypeChanged(): void {
            if (Meevo.Model.Guard.isSomething(this.externalUrlInput)) {
                this.externalUrlInput = this.externalUrlInput.replace(this.HTTPS_PREFIX, '').replace(this.HTTP_PREFIX, '');
                this.model.externalUrl = `${this.externalProtocolType}${this.externalUrlInput}`;
            }
            else {
                this.model.externalUrl = '';
            }
        }
        openNewBrowserTab() {
            if (Meevo.Model.Guard.isSomething(this.model.externalUrl)) {
                window.open(this.model.externalUrl, '_blank');
            }
        }

        minorChanged() {
            if (this.model.isMinor) {
                this.modalService.alert("LABEL_ALERT_ASSIGN_GUARDIAN");
                this.excludeSelf = [this.model];
            }
            else {
                this.model.guardianId = null;
                this.guardian = {};
                this.guardianTemp = {};
            }
        }

        get scheduledNotificationOptions() {
            if (!this.model || !this.model.notificationOptions) return [];

            return this.model.notificationOptions.filter(i => i.communicationType === 1795 || i.communicationType === 1833 || i.communicationType === 11045056);
        }

        get immediateNotificationOptions() {
            if (!this.model || !this.model.notificationOptions) return [];

            return this.model.notificationOptions.filter(i => i.communicationType === 1817 || i.communicationType === 1832 || i.communicationType === 2036 || i.communicationType === 2103);
        }

        get miscellaneousNotificationOptions() {
            if (!this.model || !this.model.notificationOptions) return [];

            return this.model.notificationOptions.filter(i => i.communicationType === 30423 || i.communicationType === 11045439);
        }


        get communicationTypeEnum(): any {
            return CommunicationTypeEnum;
        }

        get fiveStartRatingOptions() {
            if (!this.model || !this.model.notificationOptions) return [];

            return this.model.notificationOptions
                .filter(i => i.communicationType === CommunicationTypeEnum.FiveStarSurvey);
        }

        phoneTypeExclusionList = [Meevo.Model.PhoneTypeEnum.Work, Meevo.Model.PhoneTypeEnum.Fax, Meevo.Model.PhoneTypeEnum.Other];
        genderExclusionList = [Meevo.Model.GenderEnum.NotSpecified];


        revertToDefault(notification: Model.CommunicationTypeNotification): void {

            if (!notification.isSendDaysBeforeDefaultOverridden) {
                notification.sendDaysBefore = notification.sendDaysBeforeDefault;
            }

            if (!notification.isEmailEnabledDefaultOverridden) {
                notification.isEmailEnabled = notification.isEmailEnabledDefault;
            }

            if (!notification.isSmsEnabledDefaultOverridden) {
                notification.isSMSEnabled = notification.isSMSEnabledDefault;
            }
        }


        updateOverridden(notification: Model.CommunicationTypeNotification, propName: string) {
            if (!this.context.isReadonly) {
                notification[propName] = true;
            }
        }

        public initializeReferredByExclusionList(): void {
            if (!this.isStudentTeacherModuleEnabled) {
                this.referredByExclusionList = [Meevo.Model.ReferredByEnum.Student, Meevo.Model.ReferredByEnum.Teacher];
            }
            else {
                this.referredByExclusionList = null;
            }
        }

        public showStudentTeacherReferrerAlert(referredBy: Meevo.Model.ReferredByEnum, contentKey: string): void {

            if (referredBy && !this.isStudentTeacherModuleEnabled) {
                this.modalService.alert(contentKey, Meevo.Components.Modal.ModalTranslationModes.Translate, false, { okButtonContentKey: 'LABEL_OK' });
            }
        }

        showUseForTextMarketingOption(phone: Model.Phone) {
            return phone.type == Model.PhoneTypeEnum.Mobile;
        }

        /**
        * Handles setting if a phone should be used for SMS marketing.
        * Insures that only 1 phone number can be set for SMS marketing.
        * @param {Model.Phone} Selected phone number
        * @param {Model.Phone[]} Collection of client phone numbers
        * @return {}
        */
        setUseForTextMarketing(phone: Model.Phone, phoneNumbers: Model.Phone[]): void {
            if (phone.useForTextMarketing) {
                for (let i = 0; i < phoneNumbers.length; i++) {
                    if (phoneNumbers[i] !== phone) {
                        phoneNumbers[i].useForTextMarketing = false;
                    }
                }
            }
        }

        /**
        * Clears that a phone can't be used for SMS marketing if it's type changes to something other than mobile.
        * @param {Model.Phone} Selected phone number
        * @return {}
        */
        clearUseForTextMarketing(phone: Model.Phone): void {
            if (phone.type !== Model.PhoneTypeEnum.Mobile) {
                phone.useForTextMarketing = false;
            }
        }

        preSave() {
            this.externalUrlProtocolTypeChanged();
            super.preSave();
        }

        resetExternalUrl() : void {
            this.externalUrlInput = "";
            this.externalProtocolType = this.HTTPS_PREFIX;
        }
    }
}
